import { render, staticRenderFns } from "./AccessToTireaButton.vue?vue&type=template&id=1bbbc4b1"
import script from "./AccessToTireaButton.vue?vue&type=script&lang=js"
export * from "./AccessToTireaButton.vue?vue&type=script&lang=js"
import style0 from "./AccessToTireaButton.vue?vue&type=style&index=0&id=1bbbc4b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports